import _isNull from "lodash/isNull";
import { coerce as semverCoerce, gte as semverGte } from 'semver';
export default function isVersionGreaterThanOrEqual(currentVersion, minimumVersion) {
  const parsedCurrentVersion = semverCoerce(currentVersion);
  // coerce transform a string into SemVer instance if possible.
  // ref: https://github.com/npm/node-semver#readme

  if (_isNull(parsedCurrentVersion)) {
    throw Error(`Invalid current version: ${currentVersion}`);
  }
  return semverGte(parsedCurrentVersion, minimumVersion);
}